<template>
    <div class="allMainMenu">
        <div class="reMainMenu">
            
            <div class="menuBasic">
                <router-link :to="{ name: '홈' }">
                    <div id="menuBasic" class="home" :class="{ active: this.$store.mainMenu }"
                    @mouseover="displaySubMenu(); mainTitle();" @mouseout="noneDisplaySubMenu(); restTitle();" 
                    @click="resetChange">

                        <div class="homeImage">
                            <!-- <img class="mainImage" src="@/components/image/jungnanglogo.png" /> -->
                            <img class="mainImage" src="@/components/image/gangmenglogo.png" />
                        </div>

                    </div>
                </router-link>

                <router-link class="menuTitle" :to="{name : '주차장 소개'}">
                    <span id="menuBasic" class="firstMenu" @click="firstChange" :class="{ active: this.$store.firstMenu }"
                    @mouseover="displaySubMenu(); firstTitle();" @mouseout="noneDisplaySubMenu(); restTitle();">

                        {{MenuInfo[0].title}}
                        
                    </span>
                </router-link>

                <router-link class="menuTitle" :to="{name: '요금안내'}">
                    <span id="menuBasic" class="secondMenu" @click="secondChange" :class="{ active: this.$store.secondMenu }"
                    @mouseover="displaySubMenu(); secondTitle();" @mouseout="noneDisplaySubMenu(); restTitle();">

                        {{MenuInfo[1].title}}
                        
                    </span>
                </router-link>

                <!-- <span id="menuBasic" class="thirdMenu"
                @mouseover="displaySubMenu" @mouseout="noneDisplaySubMenu"
                :class="{ active: this.$store.thirdMenu }">
                    {{MenuInfo[2].title}}
                </span> -->

                <router-link class="menuTitle" :to="{name: '공지 사항'}">
                    <span id="menuBasic" class="FourthMenu" @click="fourthChange" :class="{ active: this.$store.fourthMenu }" 
                    @mouseover="displaySubMenu(); fourthTitle();" @mouseout="noneDisplaySubMenu(); restTitle();">
                        
                        {{MenuInfo[3].title}}
                    
                    </span>
                </router-link>

            </div>
        </div>

        <div id="subBasicMenu" class="subBasicMenu"
        @mouseover="displaySubMenu" @mouseout="noneDisplaySubMenu">

            <div class="first"
            @mouseover="displaySubMenu" @mouseout="noneDisplaySubMenu">
                <div class="firstTitle">{{title}}</div>
            </div>

            <div class="firstSubmenu" @mouseover="firstTitle" @mouseout="restTitle">
                <router-link :to="{ name: '주차장 소개' }">
                    <div class="submenu" @click="firstChange">
                        {{MenuInfo[0].submenu1}}
                    </div>
                </router-link>

                <!-- <router-link :to="{ name: '담당부서 안내' }">
                    <div class="submenu" @click="firstChange">
                        {{MenuInfo[0].submenu2}}
                    </div>
                </router-link> -->
            </div>

            <div class="secondSubmenu" @mouseover="secondTitle" @mouseout="restTitle">
                <router-link :to="{ name: '요금안내' }">
                    <div class="submenu" @click="secondChange">
                        {{MenuInfo[1].submenu1}}
                    </div>
                </router-link>

                <!-- <router-link :to="{ name: '할인안내' }">
                    <div class="submenu" @click="secondChange">
                        {{MenuInfo[1].submenu6}}
                    </div>
                </router-link> -->

                <router-link :to="{ name: '노상주차장 현황' }">
                    <div class="submenu" @click="secondChange">
                        {{MenuInfo[1].submenu2}}
                    </div>
                </router-link>

                <router-link :to="{name: '안내사항'}">
                    <div class="submenu" @click="secondChange">
                        {{MenuInfo[1].submenu5}}
                    </div>
                </router-link>

                <router-link :to="{ name: '확인' }">
                    <div class="submenu" @click="secondChange">
                        {{MenuInfo[1].submenu3}}
                    </div>
                </router-link>

                <!-- 시간권 부분 -->
                <!-- <router-link :to="{ name: '정보' }">
                    <div index="2-4" @click="defaultActive">
                        {{MenuInfo[1].submenu4}}
                    </div>
                </router-link> -->
            </div>

            <!-- <div class="thirdSubmenu" @mouseover="thirdTitle" @mouseout="restTitle">
                <router-link :to="{ name: '실시간정보' }">
                    <div class="submenu" @click="thirdChange">
                        {{MenuInfo[2].submenu1}}
                    </div>
                </router-link> -->

                <!-- 미납 부분 -->
                <!-- <router-link :to="{ name: '미납정보' }">
                    <div class="submenu">
                       {{MenuInfo[2].submenu2}}
                    </div>
                </router-link> -->
            <!-- </div> -->

            <div class="forthSubmenu" @mouseover="fourthTitle" @mouseout="restTitle">
                <router-link :to="{ name: '공지 사항' }">
                    <div class="submenu" @click="fourthChange">
                        {{MenuInfo[3].submenu1}}
                    </div>
                </router-link>

                <router-link :to="{ name: '자주하는 질문' }">
                    <div class="submenu" @click="fourthChange">
                       {{MenuInfo[3].submenu2}}
                    </div>
                </router-link>

                <router-link :to="{ name: '차량변경/환불요청' }">
                    <div class="submenu" @click="fourthChange">
                        {{MenuInfo[3].submenu3}}
                    </div>
                </router-link>
            </div>

        </div>

    </div>
</template>

<script>
import Menu from '@/assets/index/menu'

export default {
    data() {
        return {
            MenuInfo : Menu,
            title: "전체",
        }
    },
    methods: {
        firstChange() {

            if(this.$store.firstMenu == false) {

                this.$store.mainMenu = false,
                this.$store.firstMenu = true,
                this.$store.secondMenu = false,
                this.$store.thirdMenu = false,
                this.$store.fourthMenu = false

            } else {

                this.$store.mainMenu = false,
                this.$store.firstMenu = true,
                this.$store.secondMenu = false,
                this.$store.thirdMenu = false,
                this.$store.fourthMenu = false
            }

            const subBasicMenu = document.getElementById("subBasicMenu");

            if(subBasicMenu.style.display == 'flex') {
                subBasicMenu.style.display = 'none'
            } else {
                subBasicMenu.style.display = 'none'
            }
            
        },
        secondChange() {

            if(this.$store.isSubmit == true) {

                this.$store.isCoin = false;
                this.$store.isSubmit = false;

            } else if(this.$store.isCoin == true) {

                this.$store.isCoin = false;
                this.$store.isSubmit = false;
                
            }

            if(this.$store.secondMenu == false) {

                this.$store.mainMenu = false,
                this.$store.firstMenu = false,
                this.$store.secondMenu = true,
                this.$store.thirdMenu = false,
                this.$store.fourthMenu = false

            } else {

                this.$store.mainMenu = false,
                this.$store.firstMenu = false,
                this.$store.secondMenu = true,
                this.$store.thirdMenu = false,
                this.$store.fourthMenu = false
            }

            const subBasicMenu = document.getElementById("subBasicMenu");

            if(subBasicMenu.style.display == 'flex') {
                subBasicMenu.style.display = 'none'
            } else {
                subBasicMenu.style.display = 'none'
            }
        },
        thirdChange() {

            if(this.$store.thirdMenu == false) {

                this.$store.mainMenu = false,
                this.$store.firstMenu = false,
                this.$store.secondMenu = false,
                this.$store.thirdMenu = true,
                this.$store.fourthMenu = false

            } else {
                
                this.$store.mainMenu = false,
                this.$store.firstMenu = false,
                this.$store.secondMenu = false,
                this.$store.thirdMenu = true,
                this.$store.fourthMenu = false
            }

            const subBasicMenu = document.getElementById("subBasicMenu");

            if(subBasicMenu.style.display == 'flex') {
                subBasicMenu.style.display = 'none'
            } else {
                subBasicMenu.style.display = 'none'
            }
        },
        fourthChange() {

            if(this.$store.fourthMenu == false) {

                this.$store.mainMenu = false,
                this.$store.firstMenu = false,
                this.$store.secondMenu = false,
                this.$store.thirdMenu = false,
                this.$store.fourthMenu = true

            } else {

                this.$store.mainMenu = false,
                this.$store.firstMenu = false,
                this.$store.secondMenu = false,
                this.$store.thirdMenu = false,
                this.$store.fourthMenu = true
            }
            const subBasicMenu = document.getElementById("subBasicMenu");

            if(subBasicMenu.style.display == 'flex') {
                subBasicMenu.style.display = 'none'
            } else {
                subBasicMenu.style.display = 'none'
            }
        },
        resetChange() {
            
            if(this.$store.mainMenu == false) {

                this.$store.mainMenu = true;
                this.$store.firstMenu = false;
                this.$store.secondMenu = false;
                this.$store.thirdMenu = false;
                this.$store.fourthMenu = false;

            } else {

                this.$store.mainMenu = true;
                this.$store.firstMenu = false;
                this.$store.secondMenu = false;
                this.$store.thirdMenu = false;
                this.$store.fourthMenu = false;

            }

            const subBasicMenu = document.getElementById("subBasicMenu");

            if(subBasicMenu.style.display == 'flex') {
                subBasicMenu.style.display = 'none'
            } else {
                subBasicMenu.style.display = 'none'
            }
            
        },
        restTitle() {
            this.title = "전체"
        },
        mainTitle(){
            this.title = "전체"
        },
        firstTitle() {
            this.title = "사업소개"
        },
        secondTitle() {
            this.title = "이용안내"
        },
        thirdTitle() {
            this.title = "주차정보"
        },
        fourthTitle() {
            this.title = "고객지원"
        },
        displaySubMenu() {

            const subBasicMenu = document.getElementById("subBasicMenu");

            if(subBasicMenu.style.display == 'none') {
                subBasicMenu.style.display = 'flex'
            } else {
                subBasicMenu.style.display = 'flex'
            }

        },
        noneDisplaySubMenu() {

            const subBasicMenu = document.getElementById("subBasicMenu");

            if(subBasicMenu.style.display == 'flex') {
                subBasicMenu.style.display = 'none'
            } else {
                subBasicMenu.style.display = 'none'
            }
        }
    }
}
</script>

<style scoped>

    /* 전체 위치 */
    .reMainMenu {
        display: flex;
        margin: auto;
        text-align: center;
        max-width: 1200px;
        width: 90% !important;
        /* height: 100px; */
        background-color: #FFFFFF !important;
        font: inherit !important; 
    }

    .menuBasic {
        width: 100%;
        
    }
    
    /* .mainImage {
        width: 100%;
    } */

    /* #menuBasic {
        float: left;
        width: 18.6993%;
        height: 45px;
        padding-top: 2.8%;
        padding-bottom: 1.55%;
        text-align: center;
        font: normal normal 20px/29px Noto Sans KR-BOLD;
        letter-spacing: -0.5px;
        color: #5A5B5E;
    } */

    #menuBasic {
        float: left;
        width: 24.9323%;
        height: 45px;
        padding-top: 2.8%;
        padding-bottom: 1.55%;
        text-align: center;
        font: normal normal 20px/29px Noto Sans KR-BOLD;
        letter-spacing: -0.5px;
        color: #5A5B5E;
        background: #FFFFFF;
    }

    .menuTitle {
        text-decoration: none;
        background: #FFFFFF;
        color: #5A5B5E;
    }

    .menuTitle:hover{
        background: transparent linear-gradient(180deg, #C6DAF4 0%, #DCEAF7 100%) 0% 0% no-repeat padding-box;
    }

    .router-link-active >>> #menuBasic {
        height: 42px;
        border-bottom: 4px solid #008FD2 !important; 
        border-width: 10px;
        display: inline;
    }

    #menuBasic.active {
        height: 42px;
        border-bottom: 4px solid #008FD2 !important; 
        border-width: 10px;
        display: inline;
    }

    #menuBasic:hover {
        /* padding-bottom: 1.7%; */
        background: transparent linear-gradient(180deg, #C6DAF4 0%, #DCEAF7 100%) 0% 0% no-repeat padding-box;
    }

    /* logo 부분 */
    .home {
        padding-top: 1.8% !important;
        padding-bottom: 2.6% !important;
        width: 25.204% !important;
    }

    .home:hover {
        /* padding-bottom: 2.3% !important; */
        background: #FFFFFF 0% 0% no-repeat padding-box !important;
    }

    /* .homeImage.active {
        height: 42px;
        border-bottom: 1px solid #ffffff !important; 
        border-width: 10px;
        display: inline;
    } */

    .router-link-active >>> #menuBasic.home {
        height: 45px;
        border-bottom: transparent !important; 
        border-width: 10px;
        display: inline;
    }

    #menuBasic.home.active {
        height: 45px;
        border-bottom: transparent !important; 
        border-width: 10px;
        display: inline;
    }

    #subBasicMenu {
        display: none;
    }

    .subBasicMenu {
        display: flex;
        margin: auto;
        text-align: center;
        max-width: 1200px;
        width: 90% !important;
        max-height: 600px;
        height: 242px;
        background-color: #FFFFFF !important;
        font: inherit !important; 
        box-shadow: 0px 5px 5px hsla(216, 3%, 36%, 0.4);
    }

    .first {
        width: 25.204%;
        max-height: 600px;
        height: 100%;
        padding: auto;
        background: transparent linear-gradient(180deg, #C6DAF4 0%, #DCEAF7 100%) 0% 0% no-repeat padding-box;
        font: normal normal 24px/35px Noto Sans KR-BOLD;
        letter-spacing: -0.6px;
        color: #222222;
    }

    .firstTitle {
        padding-top: 15%;
    }

    .first >>> p {
        margin-top: 10%;
    }

    /* 서브메뉴 설정 */
    .submenu {
        width: 100%;
        max-width: 1200px;
        padding-top: 3%;
        padding-bottom: 3%;
        float: left;
        font: normal normal normal 18px/26px Noto Sans KR;
        letter-spacing: -0.5px;
        color: #595b5f;
    }

    .submenu:hover {
        background: #acb0cf 0% 0% no-repeat padding-box !important;
    }

    /* router bold */
    .router-link-active >>> .submenu {
        font: normal normal 18px/26px Noto Sans KR-BOLD;
        letter-spacing: -0.5px;
        color: #5A5B5E;
    }

    /* 각 메뉴 넓이 */
    /* .firstSubmenu {
        width: 18.7%
    }

    .secondSubmenu {
        width: 18.7%
    }

    .thirdSubmenu {
        width: 18.7%
    }

    .forthSubmenu {
        width: 18.7%
    } */

    .firstSubmenu {
        width: 25.204%
    }

    .secondSubmenu {
        width: 25.204%
    }

    .forthSubmenu {
        width: 25.204%
    } 

    /* 반응형 웹 CSS */
    @media all and (max-width: 1200px) {
        .reMainMenu  {
            width: 99vw !important;
        }

        .subBasicMenu {
            width: 99vw !important;
            height: 28vh;
        }

        .first {
            height: 28vh;
        }
        
        .menuBasic {
            width: 99vw !important;
            overflow: hidden;
        }
    }

    @media all and (max-height: 600px) {

        .subBasicMenu {
            width: 99vw !important;
            height: 48.7vh;
        }

        .first {
            height: 48.7vh;
        }
        
    }
</style>